(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["golzar-guidance-chat"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gh-guidance-chat]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    try {
      for (let attempt = 0; attempt < 20; attempt += 1) {
        const chat = document.querySelector('shopify-chat');
        if (chat && typeof chat.show === 'function') { chat.show(); return; }
        const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
        if (runtime && typeof runtime.openFromActivator === 'function') { runtime.openFromActivator(); return; }
        if (runtime && typeof runtime.show === 'function') { runtime.show(); return; }
        await new Promise((resolve) => setTimeout(resolve, 250));
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mixed-kit-flush-plate-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mixed-kit-plate-picker')) {
  customElements.define('mixed-kit-plate-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"]')) {
          this.querySelector('[data-selected-plate-code]').textContent = event.target.dataset.plateSku || '';
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["required-items-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('required-items-picker')) {
    customElements.define('required-items-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.matches('input')) event.preventDefault(); });
        this.addEventListener('click', async event => {
          const selectedPlate=event.target.closest('[data-required-variant]');
          if(selectedPlate){
            event.preventDefault();
            event.stopPropagation();
            const row=selectedPlate.closest('[data-required-row]');
            row.querySelectorAll('[data-required-variant]').forEach(choice=>choice.setAttribute('aria-pressed',String(choice===selectedPlate)));
            row.querySelector('.required-items-price').textContent=selectedPlate.dataset.variantPrice;
            const sku=row.querySelector('[data-required-sku]');
            if(sku)sku.textContent=selectedPlate.dataset.variantSku;
            row.querySelector('[data-required-plate-selection]').textContent=selectedPlate.title;
            const add=row.querySelector('[data-required-add]');
            add.dataset.variantId=selectedPlate.dataset.variantId;
            add.disabled=selectedPlate.dataset.variantAvailable!=='true';
            const image=row.querySelector('.required-items-image img');
            if(image&&selectedPlate.dataset.variantImage){image.src=selectedPlate.dataset.variantImage;image.removeAttribute('srcset');}
            return;
          }
          const button = event.target.closest('[data-required-add]');
          if (!button || button.disabled) return;
          event.preventDefault();
          event.stopPropagation();
          const row = button.closest('[data-required-row]');
          const quantity = row.querySelector('input');
          if (!quantity.reportValidity()) return;
          const status = row.querySelector('.required-items-status');
          const drawer = document.querySelector('cart-drawer');
          status.hidden = true;
          button.disabled = true;
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
              body: JSON.stringify({items:[{id:button.dataset.variantId,quantity:Number(quantity.value)}],sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
            status.textContent = status.dataset.success;
            if (drawer?.renderContents && result.sections?.['cart-drawer']) {
              drawer.setActiveElement?.(button);
              drawer.classList.remove('is-empty');
              drawer.renderContents(result);
            } else if (result.sections?.['cart-icon-bubble']) {
              const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
              const badge = document.getElementById('cart-icon-bubble');
              if (badge) badge.innerHTML = parsed.querySelector('.shopify-section')?.innerHTML || parsed.body.innerHTML;
            }
          } catch (error) { status.textContent = error.message || status.dataset.error; }
          finally { status.hidden = false; button.disabled = false; }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stock-contact-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('stock-contact-dialog');
  if (!dialog) return;
  const whatsapp = document.getElementById('stock-contact-whatsapp');
  const error = document.getElementById('stock-contact-error');
  let stockMessage = '';
  window.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-stock-contact]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    error.hidden = true;
    const title = trigger.dataset.productTitle || '';
    const url = new URL(trigger.dataset.productUrl || location.pathname, location.origin);
    const container = trigger.closest('product-info') || document;
    const variantId = container.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const data = document.getElementById('stock-contact-variants');
    let variant;
    if (data && !trigger.closest('.collection-grid-item')) {
      try { variant = JSON.parse(data.textContent).find(item => String(item.id) === variantId); } catch {}
      if (variantId) url.searchParams.set('variant', variantId);
    }
    const details = [title, variant?.title !== 'Default Title' ? variant?.title : '', variant?.sku].filter(Boolean).join(' — ');
    document.getElementById('stock-contact-product').textContent = details;
    stockMessage = 'Check Stock: Hi, could you please confirm availability for ' + details + '?\n' + url.href;
    whatsapp.href = 'https://wa.me/14167004346?text=' + encodeURIComponent(stockMessage);
    dialog.showModal();
  }, true);
  dialog.querySelector('.stock-contact-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  document.getElementById('stock-contact-message').addEventListener('click', async event => {
    const button = event.currentTarget;
    button.disabled = true;
    try {
      const host = document.querySelector('shopify-chat');
      if (!host) throw new Error('Chat unavailable');
      await Promise.race([customElements.whenDefined('shopify-chat'), new Promise((_, reject) => setTimeout(() => reject(new Error('Chat loading')), 6000))]);
      if (typeof host.sendStarterMessage === 'function') {
        await host.sendStarterMessage(stockMessage, 'typed');
        if (typeof host.show === 'function') host.show();
      }
      else if (typeof host.show === 'function') await host.show();
      else if (typeof host.open === 'function') await host.open();
      else {
        const activator = host.shadowRoot?.querySelector('button.activator, button[part="activator"], button');
        if (!activator) throw new Error('Chat unavailable');
        activator.click();
      }
      dialog.close();
    } catch { error.hidden = false; }
    finally { button.disabled = false; }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
